<script lang="ts">
  type Type = "info" | "warning";
  export let type: Type;

  $: emoji = type == "warning" ? "⚠️" : "ℹ️"
</script>

<div class="message">
  <span class="emoji">{emoji}</span>
   <slot />
</div>

<style>
  .message {
    padding: 8px 16px;
    border: 1px solid rgba(0,0,0,.2);
    border-radius: 4px;
    font-size: .85rem;
  }

  .emoji {
    margin-right: 8px;
    font-family: "Twemoji Mozilla", "Apple Color Emoji", "Segoe UI Emoji", "Noto Color Emoji", "EmojiOne Color";
  }
</style>